import BaseModel from '../core/BaseModel'
export default class StateModel extends BaseModel {

    constructor() {
        super({
                name: "state",
                tableName: 'state',
                label: "state",
            display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Name'
                },
            })
    }

}